
import React, { Component, Fragment } from 'react';
import { connect }  from 'react-redux';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';

const styles = theme => ({  
  divColorOption: {
    width: '90%',
    height: '90%',   
    ['-webkit-transition']: 'all 0.2s ease',
    ['-moz-transition']: 'all 0.2s ease',
    ['-o-transition']: 'all 0.2s ease',
    ['-ms-transition']: 'all 0.2s ease',
    transition: 'all 0.2s ease',    
    cursor: 'pointer',
    '&:focus': {
      outline:'none',      
      userSelect: 'none',
    },
    '&:hover': {
      width: '100%',
      height: '100%',
    },
  },
  divDentro: {
    borderRadius:'50%',  
    width: '100%',
    height: '100%', 
    border: '1px solid black',
    userSelect: 'none',
    outline:'none',
        '&:focus': {
      outline:'none',      
      userSelect: 'none',
    }

  },
  divColorContainer: {
    height:42,
    width:42,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
    outline:'none',
    margin: '2%',
        '&:focus': {
      outline:'none',      
      userSelect: 'none',
    }

  },
});

class FW_ColorPickerOption extends React.Component {

  handleClickListItem = (evt) => {
  }
  
  render() {
    const { classes, color, listener } = this.props;
       
    console.log('--> props',this.props,color)

    return (
      <React.Fragment>
        <div className={classes.divColorContainer} onClick={() => (listener(color))}>
          <div className={classes.divColorOption}>
            <div className={classes.divDentro} style={{backgroundColor:color}} />
          </div>        
        </div>
      </React.Fragment>    
    );    
  }
}  
  
FW_ColorPickerOption.propTypes = {
  classes: PropTypes.object.isRequired,
};

FW_ColorPickerOption.contextTypes = {
  store: PropTypes.object,
};

export default connect()(withStyles(styles,{ withTheme: true })(FW_ColorPickerOption));




// WEBPACK FOOTER //
// ./src/containers/components/FW_ColorPickerOption.js